"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui";

const FAQAccordion = () => {
  const faqs = [
    {
      question: "How do I get started with the platform?",
      answer: "Getting started is easy! Simply sign up for an account, choose your plan, and follow our onboarding guide. Our team will help you set up your workspace and import your existing data."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards, PayPal, and offer enterprise billing options including invoicing and purchase orders for annual subscriptions."
    },
    {
      question: "Can I change my plan at any time?",
      answer: "Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately, and we'll prorate any billing adjustments on your next invoice."
    },
    {
      question: "Is there a free trial available?",
      answer: "We offer a 14-day free trial for all plans. No credit card required to start your trial, and you'll have access to all features during the trial period."
    },
    {
      question: "How secure is my data?",
      answer: "We take security seriously. All data is encrypted in transit and at rest, we're SOC 2 compliant, and we regularly undergo security audits. Your data is backed up daily across multiple locations."
    },
    {
      question: "Do you offer customer support?",
      answer: "Yes! We provide email support for all plans, priority support for Professional plans, and dedicated support for Enterprise customers. Our average response time is under 2 hours."
    },
    {
      question: "Can I integrate with other tools?",
      answer: "Absolutely! We offer native integrations with popular tools like Slack, Google Workspace, Microsoft 365, and many others. We also provide a comprehensive API for custom integrations."
    },
    {
      question: "What happens if I cancel my subscription?",
      answer: "You can cancel anytime. Your account will remain active until the end of your billing period, and you'll have 30 days to export your data before account closure."
    }
  ];

  return (
    <div className="max-w-3xl mx-auto">
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger className="text-left">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent>
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FAQAccordion;
